import { c as _c } from "react/compiler-runtime";
import { Link } from '@/frontend/design-system/actions/Link';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
type TopArticle = {
  id: string;
  name: string;
  collectionId: string;
};

// TODO
export function TopHits() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      id: "1",
      name: "Artyku\u0142 1",
      collectionId: "col1"
    }, {
      id: "2",
      name: "Artyku\u0142 2",
      collectionId: "col2"
    }, {
      id: "3",
      name: "Artyku\u0142 3",
      collectionId: "col3"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const topArticles = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-3"><P2 className="font-semibold text-contentSecondary">Popularne</P2>{topArticles.map(_temp)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(article) {
  return <Link key={article.id} href={`/baza/${article.collectionId}/${article.id}`} className="rounded-lg bg-backgroundSecondary px-3 py-3 hover:bg-backgroundBlue hover:text-contentBlue"><P2 className="text-current">{article.name}</P2></Link>;
}